/**
 * 获取会话信息，不受权限控制
 */

import { useQuery } from '@tanstack/react-query';
import { getConversationListByIds } from 'services/api/conversation.convList';
import { useSetConversation } from './lruConversation';
import { useEffect } from 'react';
import { toNumber } from 'lodash-es';
import { useSetConversationReadonly, useSetCurrentConversationIdValue } from './conversation';
import { message } from 'antd';
import { useTranslate } from '@tolgee/react';

interface Props {
  conversationId: string;
  enabled: boolean;
  readonly?: boolean;
}

export const useConversationInfo = (props: Props) => {
  const { conversationId, enabled, readonly = false } = props;
  const setConversation = useSetConversation();
  const setCurrentConversationId = useSetCurrentConversationIdValue();
  const setConversationReadonly = useSetConversationReadonly();
  const { t } = useTranslate();

  const {
    isLoading: loading,
    data: conversation,
    error,
  } = useQuery({
    enabled,
    queryKey: ['conversationListById', conversationId],
    queryFn: ({ signal }) => {
      return getConversationListByIds([toNumber(conversationId)], signal);
    },
    select: (data) => {
      return data?.talkInfo?.[0];
    },
    staleTime: 60 * 1000,
  });

  useEffect(() => {
    if (error) {
      message.error(t('phrase.获取数据失败，请稍后再试'));
    }
  }, [error, t]);

  useEffect(() => {
    if (conversation) {
      setConversation(conversationId, conversation);
      setCurrentConversationId(conversationId);
    }
    return () => {
      setCurrentConversationId(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversationId, conversation]);

  useEffect(() => {
    setConversationReadonly(readonly);
    return () => setConversationReadonly(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [readonly]);

  return { loading, conversation };
};
